export default __webpack_public_path__ + "static/before-1-ad2c53d33c9d45794ac1acb2c78c6866.png";